import httpClient from "./httpClient";
import { ANIMAL_SPLIT_CORE } from "../constants";

const API_BASE_URL = ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL;

/**
 * Abstract seat management service
 * Game-agnostic operations for managing seats in any room
 */

/**
 * Take a seat in a room
 * @param {string} roomId - Room ID
 * @param {number} seatPosition - Seat index (0-based)
 * @param {string} playerName - Player name
 */
export const takeSeat = async (roomId, seatPosition, playerName) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/room/${roomId}/take-seat`, {
    seatPosition,
    playerName,
  });
  return response.data;
};

/**
 * Leave a seat in a room
 * @param {string} roomId - Room ID
 * @param {number} seatPosition - Seat index (0-based)
 */
export const leaveSeat = async (roomId, seatPosition) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/room/${roomId}/leave-seat`, {
    seatPosition,
  });
  return response.data;
};
